export default __webpack_public_path__ + "static/media/CSA-2023 - Logo.79c81ef0.png";